import { generalConstants } from '@tweddle-se-team/common/constants'

const { WTY } = generalConstants

const toYear = year => {
  const parsedYear = Number(year)
  return Number.isInteger(parsedYear) ? parsedYear : null
}

const toTimestamp = date => {
  const timestamp = new Date(date).getTime()
  return Number.isNaN(timestamp) ? 0 : timestamp
}

export const buildServiceWarrantyInventoryFilters = (filters = {}) => ({
  brand: filters.brand,
  model: filters.model,
  modelType: filters.modelType,
  language: filters.language,
  publicationType: WTY
})

export const getPublicationDisplayYear = publication => publication?.serviceWarrantyDisplayYear || publication?.year

export const getPublicationUiKey = publication =>
  publication?.publicationType === WTY
    ? `${publication._id}-service-warranty-${getPublicationDisplayYear(publication)}`
    : publication?._id

export const findClosestServiceWarrantyPublication = (publications = [], targetYear) => {
  const normalizedTargetYear = toYear(targetYear)
  if (normalizedTargetYear === null) return null

  return (
    publications
      .filter(publication => {
        const publicationYear = toYear(publication.year)
        return (
          publication.publicationType === WTY && publicationYear !== null && publicationYear <= normalizedTargetYear
        )
      })
      .sort((publicationA, publicationB) => {
        const yearDifference = toYear(publicationB.year) - toYear(publicationA.year)
        if (yearDifference) return yearDifference
        return toTimestamp(publicationB.lineOffDate) - toTimestamp(publicationA.lineOffDate)
      })[0] || null
  )
}

const createServiceWarrantyDisplayPublication = (publication, targetYear) => ({
  ...publication,
  serviceWarrantyDisplayYear: String(targetYear)
})

export const mixServiceWarrantyPublicationForYear = ({
  publications = [],
  serviceWarrantyPublications = [],
  targetYear
}) => {
  const publicationsWithoutServiceWarranty = publications.filter(publication => publication.publicationType !== WTY)
  const normalizedTargetYear = toYear(targetYear)
  const sourcePublication = findClosestServiceWarrantyPublication(serviceWarrantyPublications, normalizedTargetYear)
  if (!sourcePublication) return publicationsWithoutServiceWarranty

  const result = [...publicationsWithoutServiceWarranty]
  const displayPublication = createServiceWarrantyDisplayPublication(sourcePublication, normalizedTargetYear)
  let insertAfterIndex = -1

  for (let index = result.length - 1; index >= 0; index--) {
    if (toYear(getPublicationDisplayYear(result[index])) === normalizedTargetYear) {
      insertAfterIndex = index
      break
    }
  }

  if (insertAfterIndex === -1) result.push(displayPublication)
  else result.splice(insertAfterIndex + 1, 0, displayPublication)

  return result
}
